
import { Company } from "@/models/company";
import { CRM, CRMEvent } from "@/models/crm";
import { CompanyService } from "@/services/company-service";
import { ISelectItem } from "winfakt-vue-components/src/classes";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			crm: new CRM(),
			keys: [] as string[],
			values: [] as string[],
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	computed: {
		items():ISelectItem<CRMEvent>[]{
			return [
				{
					text: "Review bericht verzonden",
					value: CRMEvent.CRM_EVENT_REVIEW_MESSAGE_SENT
				},
				{
					text: "Initiele SP mail verzonden",
					value: CRMEvent.CRM_EVENT_INITIAL_SP_MAIL_SENT
				},
				{
					text: "SP mail verzonden",
					value: CRMEvent.CRM_EVENT_SP_MAIL_SENT
				}
			];
		},
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.isValid) return;
			this.crm.metadata = {};
			for (let i in this.keys) {
				this.crm.metadata[this.keys[i]] = this.values[i];
			}
			await CompanyService.createCrm(this.company.id, this.crm);
			this.$emit("saved");
			this.$emit("close");
		},
		addMetaDataField(){
			this.values.push("");
			this.keys.push("");
		},
		removeMetaDataField(i:number){
			this.values.splice(i, 1);
			this.keys.splice(i, 1);
		},
		extendValidate(){
			this.isValid = true;
			this.keys.forEach((key, index)=>{
				let foundIndex = this.keys.indexOf(key);
				if (foundIndex != index){
					this.isValid = false;
				}
			});
		}
	}
});
